module.exports = __webpack_public_path__ + "videos/mts-products-chats-one-click-call.5c9cc2d.webm";